import { useCallback, useMemo } from "react"

import { Tabs, TabsList, TabsTrigger } from "../../common/components/tabs"
import { ClFarmsAlmType } from "../types"

export type ClFarmsAlmTabsProps = {
  value: string
  onValueChange: (value: ClFarmsAlmType | "all") => void
  className: string | undefined
  availableTabs: ClFarmsAlmType[]
}

const defaultValue = "all"

const isValidValue = (v: string, availableTabs: ClFarmsAlmType[]): v is ClFarmsAlmType | "all" => {
  return v === "all" || availableTabs.includes(v as ClFarmsAlmType)
}

export const ClFarmsAlmTabs = ({ value, onValueChange, className, availableTabs }: ClFarmsAlmTabsProps) => {
  const handleValueChange = useCallback(
    (value: string) => {
      if (!isValidValue(value, availableTabs)) {
        console.warn(`Invalid tab value: ${value}`)
        return defaultValue
      }

      onValueChange(value)
    },
    [onValueChange, availableTabs],
  )

  // Combine "all" with available ALM tabs
  const allTabs = useMemo(() => ["all" as const, ...availableTabs], [availableTabs])

  return (
    <Tabs
      value={isValidValue(value, availableTabs) ? value : defaultValue}
      defaultValue={defaultValue}
      onValueChange={handleValueChange}
    >
      <TabsList className={className}>
        {allTabs.map((tab) => (
          <TabsTrigger key={tab} value={tab}>
            {tab === "all" ? "All" : tab}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
